import React from "react";
import { Image as KonvaImage } from "react-konva";
import styled from "styled-components";
import useImage from "use-image";

const StageWrapper = ({ children }) => {
  return <StyledStageWrapper>
    <div className="stage-children">
      {children}
    </div>
  </StyledStageWrapper>;
};
export default StageWrapper;

const StyledStageWrapper = styled.div`
  padding: 20px;
  flex: 0 0 calc(100% - 400px);
  max-width: calc(100% - 400px);

  @media (max-width: 991px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .spinner {
    z-index: 99999 !important;
  }
  
    
  .stage-children {
     position: relative;
      flex-grow: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background-color: #f8f8f8;
      height: 100%;
      border-radius: 15px;
  }

  @media (max-width: 991px) {

  }

  .gridStage {
    position: fixed;
    top: 0;
    left: auto;
    width: calc(100% - 320px);
    height: 100%;
    pointer-events: none;
  }

  .konva-stage {
    @media (min-width: 992px) {
      /* flex-grow: 1;
      display: flex; */
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    @media (max-width: 991px) {
      /* transform-origin: center !important; */
      padding: 30px;
    }
  }
`;
